// src/components/ProjectModal.jsx
import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import zIndex from "@mui/material/styles/zIndex";
import { Link } from "react-router-dom";

const overlayVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
    exit: { opacity: 0 },
};

const modalVariants = {
    hidden: { opacity: 0, y: 24, scale: 0.98 },
    visible: { opacity: 1, y: 0, scale: 1, transition: { type: "spring", stiffness: 300, damping: 30 } },
    exit: { opacity: 0, y: 24, scale: 0.98 },
};

export default function ProjectModal({ project, popFlag, setPopFlag }) {
    // Lock scroll while modal is open
    useEffect(() => {
        if (popFlag) return;
        const previous = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => { document.body.style.overflow = previous; };
    }, [popFlag]);

    // ESC to close
    useEffect(() => {
        if (popFlag) return;
        const onKey = (e) => { if (e.key === "Escape") setPopFlag(false); };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [popFlag, setPopFlag]);

    return (
        <AnimatePresence>
            <motion.div
                className="modal-overlay"
                role="dialog"
                aria-modal="true"
                aria-label={project?.name ? `${project.name} details` : "Project details"}
                onClick={(e) => {
                    // close when backdrop clicked (but not when content clicked)
                    if (e.target === e.currentTarget) {
                        setPopFlag(false);
                    }
                }}
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={overlayVariants}
            >
                <motion.div
                    className="modal-content"
                    variants={modalVariants}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    layout
                >
                    <div className="modal-top-bar">
                        <button
                            className="macos-close"
                            onClick={() => setPopFlag(false)}
                            aria-label="Close"
                            title="Close"
                        />

                        <div className="project-links">
                            {project.links.link ?
                                <Link to={project.links.link} target="_blank">
                                    <i className="fa-solid fa-link"></i>
                                </Link>
                                : ""}
                            {project.links.doc ?
                                <Link to={project.links.doc} target="_blank">
                                    <i className="fa-solid fa-file"></i>
                                </Link>
                                : ""}
                            {project.links.github ?
                                <Link to={project.links.github} target="_blank">
                                    <i className="fa-brands fa-github"></i>
                                </Link>
                                : ""}
                        </div>
                    </div>

                    {/* Media */}
                    <div className="modal-media">
                        {project?.video ? (
                            <video
                                src={project.video}
                                autoPlay
                                muted
                                loop
                                controls
                                playsInline
                                className="modal-video"
                            />
                        ) : project?.image ? (
                            <img src={project.image} alt={project.name || "Project"} className="modal-image" />
                        ) : (
                            <div className="modal-placeholder">No preview available</div>
                        )}
                    </div>

                    {/* Text */}
                    <div className="modal-body">
                        {project?.name && <h3 className="modal-title">{project.name}</h3>}
                        {project?.desc && <p className="modal-desc">{project.desc}</p>}
                        {project?.desc2 && <p className="modal-desc">{project.desc2}</p>}
                    </div>
                </motion.div>
            </motion.div>
        </AnimatePresence>
        // <>
        // <h1 style={{zIndex:10, position:"absolute"}}>hey</h1>
        // </>
    );
}
